import store from '@/store'
import { storeModules } from './helpers'
import PublicProject from '@/components/Projects/PublicProject'

let orderStep = 4

// Main Views
const Login = () => import('@/views/Login')
const SSOLogin = () => import('@/views/SSOLogin')
// const HowItWorks = () => import('@/views/HowItWorks')
const SuccessOnBoardFlow = () => import('@/views/SuccessOnBoardFlow')
const ResetPassword = () => import('@/views/ResetPassword')
const ConfirmResetPassword = () => import('@/views/ConfirmResetPassword')
const MemberAcceptInvite = () => import('@/views/MemberAcceptInvite')
const Profile = () => import('@/views/ProfileMain')
const AdvancedProfileSettings = () =>
  import('@/components/Profile/AdvancedProfileSetting')
const OrdersMain = () => import('@/views/OrdersMain')
const InvetoryMain = () => import('@/views/InventoryMain')
const DashboardMain = () => import('@/views/DashboardMain')
const UsersMain = () => import('@/views/UsersMain')
const IntegrationsMain = () => import('@/views/IntegrationsMain')
const InviteMembersDashboard = () => import('@/views/InviteMembersDashboard')
const NotFound = () => import('@/views/404')
const Maintenance = () => import('@/views/503')
const UnAuthorized = () => import('@/views/UnAuthorized')
const ProjectsMain = () => import('@/views/Projects')
const Recipients = () => import('@/views/Recipients')
const Authenticate = () => import('@/views/Authenticate')
const EmailVerificationSuccess = () =>
  import('@/views/EmailVerificationSuccess')

// Nested Views
const OrderDetail = () => import('@/views/OrderDetail')
const ProjectDetails = () => import('@/components/Projects/ProjectDetails')
const RecipientDetail = () => import('@/components/Recipients/RecipientDetail')
const MapColumns = () => import('@/components/Recipients/MapColumns')
const ProjectRecipientLogin = () =>
  import('@/components/Projects/ProjectRecipientLogin')
const ProjectItemsSelection = () =>
  import('@/components/Projects/ProjectItemsSelection')
const VerifyAdminOrderRecipient = () =>
  import('@/components/Projects/VerifyRecipients')
const AddressCollectionRecipient = () =>
  import('@/components/Projects/RecipientForm')
const AddressCollectionReview = () =>
  import('@/components/Projects/AddressCollectionReview')
const AddressCollectionConfirm = () =>
  import('@/components/Projects/AddressCollectionConfirm')

// Billing
const ManageBillingMain = () => import('@/views/ManageBillingMain')
const AddPaymentMethod = () => import('@/components/Billing/AddPaymentMethod')
const AddInvoicePaymentMethod = () =>
  import('@/components/Billing/AddInvoicePaymentMethod')

// Send gift flow
const SelectRecipient = () =>
  import('@/components/SendGiftFlow/SelectRecipient')
const AddRecipient = () => import('@/components/SendGiftFlow/AddRecipient')
const LinkSalesForceRecord = () =>
  import('@/components/SendGiftFlow/LinkSalesForceRecord')
const GiftList = () => import('./components/SendGiftFlow/GiftList.vue')
const ProductDetail = () =>
  import('./components/SendGiftFlow/ProductDetail.vue')
const BundleDetail = () => import('./components/SendGiftFlow/BundleDetail.vue')
const ShoppingBag = () => import('@/components/SendGiftFlow/ShoppingBag.vue')
const CardMessage = () => import('@/components/SendGiftFlow/CardMessage.vue')
const ConfirmOrder = () => import('@/components/SendGiftFlow/ConfirmOrder')
const CardTemplatesMain = () =>
  import('@/components/CardTemplates/CardTemplatesMain')
const NewCardTemplates = () =>
  import('@/components/CardTemplates/NewCardTemplates')
const Settings = () => import('@/views/Settings')

// Group Order Creation
const GroupOrderNew = () => import('@/components/GroupOrder/GroupOrderNew')
const GroupOrderEdit = () => import('@/components/GroupOrder/GroupOrderEdit')

const GroupOrderCreate = () =>
  import('@/components/GroupOrder/GroupOrderCreate')
const GroupOrderDetails = () =>
  import('@/components/GroupOrder/GroupOrderDetails')
const GroupOrderItemsSelection = () =>
  import('@/components/GroupOrder/GroupOrderItemsSelection')

const GroupOrderInfo = () => import('@/components/GroupOrder/GroupOrderInfo')
const GroupOrderPageAccess = () =>
  import('@/components/GroupOrder/GroupOrderPageAccess')
const GroupOrderSuccess = () =>
  import('@/components/GroupOrder/GroupOrderSuccess')
const GroupOrderListMain = () =>
  import('@/components/GroupOrder/GroupOrderListMain')

// Group Order Users Flow
const GroupOrderRecipientsLogin = () =>
  import('@/components/GroupOrder/GroupOrderRecipientsLogin')
const VerifyRecipients = () =>
  import('@/components/GroupOrder/VerifyRecipients')
const GroupOrderTierList = () =>
  import('@/components/GroupOrder/GroupOrderTierList')
const GroupOrderRecipientForm = () =>
  import('@/components/GroupOrder/GroupOrderRecipientForm')
const GroupOrderConfirmation = () =>
  import('@/components/GroupOrder/GroupOrderConfirmation')
const AddCard = () => import('@/components/GroupOrder/AddCard')
import('@/components/GroupOrder/GroupOrderConfirmation')
const ReviewOrder = () => import('@/components/GroupOrder/ReviewOrder')
const RecipientSuccessGroupOrder = () =>
  import('@/components/GroupOrder/RecipientSuccessGroupOrder')

const RecipientTracking = () => import('@/views/TrackingPage.vue')
// E-Commerce

// eslint-disable-next-line no-unused-vars
const EcommerceDetails = () => import('@/components/ECommerce/EcommerceDetails')
const EcommerceEdit = () => import('@/components/ECommerce/EcommerceEdit')
const EcommerceDashboard = () =>
  import('@/components/ECommerce/EcommerceDashboard')
const EcommerceOrders = () => import('@/components/ECommerce/EcommerceOrders')
const EcommerceSetting = () => import('@/components/ECommerce/EcommerceSetting')
const EcommerceProducts = () =>
  import('@/components/ECommerce/EcommerceProducts')
const EcommerceGiftCards = () =>
  import('@/components/ECommerce/EcommerceGiftCards')
const EcommerceGiftCardCreate = () =>
  import('@/components/ECommerce/EcommerceGiftCardCreate')
const EcommerceOrderDetails = () =>
  import('@/components/ECommerce/EcommerceOrderDetails')
const EcommercePayouts = () => import('@/components/ECommerce/ECommercePayouts')
const EcommercePayoutDetails = () =>
  import('@/components/ECommerce/EcommercePayoutDetails')

export const routes = [
  {
    path: '/projects',
    name: 'Projects',
    component: ProjectsMain,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/projects/public',
    props: true,
    name: 'PublicProject',
    component: PublicProject,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/projects/:id',
    props: true,
    name: 'ProjectDetail',
    component: ProjectDetails,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/recipient-list',
    name: 'Recipients',
    component: Recipients,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/recipient-list/map',
    name: 'MapColumns',
    component: MapColumns,
    beforeEnter: (to, from, next) => {
      if (Object.keys(store.state.recipient.recipientList).length > 0) {
        next()
      } else {
        next('/recipient-list')
      }
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/recipient-list/:id',
    props: true,
    name: 'RecipientDetail',
    component: RecipientDetail,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/profile',
    name: 'profile',
    component: Profile,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/profile/advanced',
    name: 'advanced-profile',
    component: AdvancedProfileSettings,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/report',
    name: 'report',
    component: DashboardMain,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/login/sso',
    name: 'sso-login',
    component: SSOLogin,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/authenticate',
    name: 'Authenticate',
    component: Authenticate,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/email-verification',
    name: 'EmailVerificationSuccess',
    component: EmailVerificationSuccess,
    meta: {
      requiresAuth: false
    }
  },

  {
    path: '/success-onboard-flow',
    name: 'successflow',
    component: SuccessOnBoardFlow,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/reset-password',
    name: 'resetpassword',
    component: ResetPassword,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/passwords/reset',
    name: 'confirmresetpassword',
    component: ConfirmResetPassword,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/invitations/:token',
    name: 'invitations',
    component: MemberAcceptInvite,
    beforeEnter: (to, from, next) => {
      const existingSession = window.$cookies.get('dashboard-session')

      if (existingSession) {
        window.$cookies.remove('dashboard-session')
      }
      next()
    },
    props: true,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/orders/:orderTab?',
    name: 'orders',
    component: OrdersMain,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/manage-inventory',
    name: 'inventory',
    component: InvetoryMain,
    beforeEnter: (to, from, next) => {
      // in case user want to access the page tru the URL we validate that user is admin to continue otherwise is redirected to another page
      let isTeamOwner = store.getters['profile/isTeamOwner']
      if (isTeamOwner) {
        next()
      } else {
        next({ name: 'GiftList' })
      }
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/orders/:id',
    name: 'orderdetail',
    component: OrderDetail,
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/select-recipient',
    name: 'SelectRecipient',
    component: SelectRecipient,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/add-recipient',
    name: 'AddRecipient',
    component: AddRecipient,
    meta: {
      requiresAuth: true,
      step: 2
    }
  },
  {
    path: '/link-salesforce-record',
    name: 'LinkSalesForceRecord',
    component: LinkSalesForceRecord,
    meta: {
      requiresAuth: true,
      step: 4
    }
  },
  {
    path: '/gifts',
    name: 'GiftList',
    component: GiftList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/product-detail/:id',
    name: 'ProductDetail',
    component: ProductDetail,

    beforeEnter: (to, from, next) => {
      if (
        store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
      ) {
        next()
      } else if (
        store.state.team.team.teamModuleNames.includes(storeModules.project)
      ) {
        next({ name: 'Projects' })
      }
    },
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/bundle-detail/:id',
    name: 'BundleDetail',
    component: BundleDetail,

    beforeEnter: (to, from, next) => {
      if (
        store.state.team.team.teamModuleNames.includes(storeModules.swag_store)
      ) {
        next()
      } else if (
        store.state.team.team.teamModuleNames.includes(storeModules.project)
      ) {
        next({ name: 'Projects' })
      }
    },
    props: true,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/shopping-bag',
    name: 'ShoppingBag',
    component: ShoppingBag,
    meta: {
      requiresAuth: true,
      step: 1
    }
  },
  {
    path: '/card-message',
    name: 'CardMessage',
    component: CardMessage,
    meta: {
      requiresAuth: true,
      step: 3
    }
  },
  {
    path: '/order-confirmation',
    name: 'ConfirmOrder',
    component: ConfirmOrder,
    beforeEnter: (to, from, next) => {
      let isSalesForceConnected =
        store.getters['integration/isSalesForceConnected']

      if (isSalesForceConnected) {
        orderStep = 5
      }
      next()
    },
    meta: {
      requiresAuth: true,
      step: orderStep
    }
  },
  {
    path: '/recipients/:groupId/:token',
    name: 'RecipientTracking',
    component: RecipientTracking
  },
  {
    path: '/confirmed-order',
    name: 'ConfirmedOrder',
    component: ConfirmOrder,
    meta: {
      requiresAuth: true,
      step: (orderStep += 1)
    }
  },
  {
    path: '/order-confirmation/:id',
    name: 'ConfirmOrder',
    component: ConfirmOrder,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/manage-templates',
    name: 'ManageTemplates',
    component: CardTemplatesMain,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/settings',
    name: 'Settings',
    component: Settings,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/manage-templates/new',
    name: 'NewCardTemplates',
    component: NewCardTemplates,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/members',
    name: 'members',
    component: UsersMain,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/members/invite',
    name: 'membersInvite',
    component: InviteMembersDashboard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/integrations',
    name: 'integrations',
    component: IntegrationsMain,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/manage-billing',
    name: 'billing',
    component: ManageBillingMain,
    beforeEnter: (to, from, next) => {
      // in case user want to access the page tru the URL we validate that user is admin to continue otherwise is redirected to another page
      let isTeamOwner = store.getters['profile/isTeamOwner']
      if (isTeamOwner) {
        next()
      } else {
        next({ name: 'GiftList' })
      }
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/add-payment-method',
    name: 'AddPaymentMethod',
    component: AddPaymentMethod,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/add-invoice-method',
    name: 'AddInvoicePaymentMethod',
    component: AddInvoicePaymentMethod,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/redemption/new',
    component: GroupOrderNew,
    children: [
      {
        path: '/',
        props: true,
        name: 'GroupOrderCreate',
        component: GroupOrderCreate,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'add-card/:id',
        props: true,
        name: 'addCard',
        component: AddCard,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'review-order/:id',
        props: true,
        name: 'reviewOrder',
        component: ReviewOrder,
        meta: {
          requiresAuth: true
        }
      },

      {
        path: 'items-selection/:id',
        props: true,
        name: 'GroupOrderItemsSelection',
        component: GroupOrderItemsSelection,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'redemption-info/:id',
        props: true,
        name: 'GroupOrderInfo',
        component: GroupOrderInfo,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'redemption-page-access/:id',
        props: true,
        name: 'GroupOrderPageAccess',
        component: GroupOrderPageAccess,
        meta: {
          requiresAuth: true
        }
      }
    ],
    beforeEnter: (to, from, next) => {
      let { currentSubscription } = store.state.billing
      if (Object.keys(currentSubscription).length) {
        next()
      } else {
        store.dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              'Please select/upgrade your plan to continue sending gifts'
            ]
          },
          { root: true }
        )
        next({
          name: 'RedemptionList'
        })
      }
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/redemption/edit',
    component: GroupOrderEdit,
    children: [
      {
        path: 'items-selection/:id',
        props: true,
        name: 'EditGroupOrderItemsSelection',
        component: GroupOrderItemsSelection,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'redemption-info/:id',
        props: true,
        name: 'EditGroupOrderInfo',
        component: GroupOrderInfo,
        meta: {
          requiresAuth: true
        }
      }
    ],
    beforeEnter: (to, from, next) => {
      let { currentSubscription } = store.state.billing
      if (Object.keys(currentSubscription).length) {
        next()
      } else {
        store.dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: [
              'Please select/upgrade your plan to continue sending gifts'
            ]
          },
          { root: true }
        )
        next({ name: 'orders', params: { orderTab: 'groupOrders' } })
      }
    },
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/redemption-success',
    name: 'GroupOrderSuccess',
    component: GroupOrderSuccess,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/redemptions',
    name: 'RedemptionList',
    component: GroupOrderListMain,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/redemption/details/:id',
    props: true,
    name: 'GroupOrderDetails',
    component: GroupOrderDetails,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/recipients/:uuid?',
    name: 'GroupOrderRecipientsLogin',
    component: GroupOrderRecipientsLogin,
    props: true,
    meta: {
      requiresRecipient: false
    }
  },
  {
    path: '/recipient/verification',
    name: 'VerifyGroupOrderRecipients',
    component: VerifyRecipients,
    meta: {
      requiresRecipient: false
    }
  },
  {
    path: '/redemption/tier-selection',
    name: 'GroupOrderTierList',
    component: GroupOrderTierList,
    props: true,
    meta: {
      requiresRecipient: true
    }
  },
  {
    path: '/redemption/recipient-info',
    name: 'GroupOrderRecipientForm',
    component: GroupOrderRecipientForm,
    meta: {
      requiresRecipient: true
    }
  },
  {
    path: '/redemption/confirm-order',
    name: 'GroupOrderConfirmation',
    component: GroupOrderConfirmation,
    meta: {
      requiresRecipient: true
    }
  },
  {
    path: '/redemption/confirm-success',
    name: 'RecipientSuccessGroupOrder',
    component: RecipientSuccessGroupOrder,
    meta: {
      requiresRecipient: false
    }
  },
  {
    path: '/admin-order-recipients/verification',
    name: 'verifyAdminOrderRecipient',
    component: VerifyAdminOrderRecipient,
    meta: {
      requiresRecipient: false
    }
  },

  {
    path: '/admin-order-recipients/:uuid',
    props: true,
    name: 'ProjectRecipientLogin',
    component: ProjectRecipientLogin,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/admin-order-recipients/:uuid/items-selection',
    props: true,
    name: 'ProjectItemsSelection',
    component: ProjectItemsSelection,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/admin-order-recipients/:uuid/recipient',
    props: true,
    name: 'AddressCollectionRecipient',
    component: AddressCollectionRecipient,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/admin-order-recipients/:uuid/review',
    props: true,
    name: 'AddressCollectionReview',
    component: AddressCollectionReview,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/admin-order-recipients/:uuid/success',
    props: true,
    name: 'AddressCollectionConfirm',
    component: AddressCollectionConfirm,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/e-commerce/details',
    props: true,
    name: 'EcommerceDetails',
    component: EcommerceDashboard,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/e-commerce/orders',
    props: true,
    name: 'EcommerceOrders',
    component: EcommerceOrders,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/e-commerce/payouts',
    props: true,
    name: 'EcommercePayouts',
    component: EcommercePayouts,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/e-commerce/payouts/:id',
    props: true,
    name: 'EcommercePayoutDetails',
    component: EcommercePayoutDetails,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/e-commerce/orders/:id',
    props: true,
    name: 'EcommerceOrderDetails',
    component: EcommerceOrderDetails,
    meta: {
      requiresAuth: true
    }
  },

  {
    path: '/e-commerce/setting',
    props: true,
    name: 'EcommerceSetting',
    component: EcommerceSetting,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/e-commerce/products',
    props: true,
    name: 'EcommerceSetting',
    component: EcommerceProducts,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/e-commerce/gift-cards',
    props: true,
    name: 'EcommerceGiftCards',
    component: EcommerceGiftCards,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/e-commerce/gift-cards/create',
    props: true,
    name: 'EcommerceGiftCardCreate',
    component: EcommerceGiftCardCreate,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/e-commerce/edit',
    props: true,
    name: 'EcommerceEdit',
    component: EcommerceEdit,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/un-authorized',
    name: 'unauthorized',
    componenent: UnAuthorized,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/404',
    name: 'notfound',
    component: NotFound,
    meta: {
      requiresAuth: false
    }
  },
  {
    path: '/503',
    name: 'maintenance',
    component: Maintenance,
    meta: {
      requiresAuth: false
    }
  },
  { path: '/', redirect: '/report' },
  { path: '*', redirect: '/404' }
]

export const checkDashboardSession = async (routeTo, routeFrom, next) => {
  const existingSession = window.$cookies.get('dashboard-session')
  const recipientSession = window.$cookies.get('recipient-session')
  if (routeTo.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (existingSession) {
      // trigger action to check for team alerts related to subscriptions
      store.dispatch('billing/checkForTeamAlerts')
      store.dispatch('team/getTeam')

      localStorage.removeItem('protectedLastRoute')
      localStorage.removeItem('protectedLastRouteParams')
      if (routeTo.name === 'login') {
        next({ name: 'report' })
      } else {
        next()
      }
    } else {
      localStorage.setItem(
        'protectedLastRoute',
        routeTo.name !== undefined ? routeTo.name : 'report'
      )
      localStorage.setItem(
        'protectedLastRouteParams',
        JSON.stringify(routeTo.params)
      )
      next({ name: 'login' })
    }
  } else if (routeTo.matched.some(record => record.meta.requiresRecipient)) {
    if (recipientSession) {
      if (routeTo.name === 'GroupOrderRecipientsLogin') {
        next({ name: 'GroupOrderTierList' })
      } else {
        next()
      }
    } else {
      next({ name: 'login' })
    }
  } else {
    const exempted = ['notfound', 'invitations', 'maintenance']
    if (existingSession && !exempted.includes(routeTo.name)) {
      next({ name: 'report' })
    } else {
      next()
    }
  }
}
